export default __webpack_public_path__ + "static/media/info.dd6a4154.svg";